import {createSelector} from 'reselect';
import {getListingSummary} from './listingSummary';
import {getSuperlativeBadges} from './listing';
import {getFirstPayment, getPriceLabels, getTotals, getPriceDetails} from './priceDetails';
import {getIsMobile, getDeviceSize, getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getAbacusTests} from './store';
import {VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY} from '../abacus/experiments';
import {evaluationIsVariant} from '@homeaway/react-experiment';

const getViewDetailsTotalData = createSelector(
    [getPriceDetails, getPriceLabels, getTotals],
    (priceDetails, labels, totals) => ({
        edapPriceQuotePresented: priceDetails.edapPriceQuotePresented,
        labels,
        showViewDetailsLink: !!(totals || {}).totalWithoutDeposits,
        totals
    })
);

const getRightRailData = createSelector(
    [
        getBookingType,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        getTakesInquiries,
        getFirstPayment,
        getSuperlativeBadges,
        getIsMobile,
        getAbacusTests,
        getDeviceSize,
        getPriceDetails
    ],
    (
        bookingType,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        takesInquiries,
        firstPaymentData,
        superlativeBadges,
        isMobile,
        abacusTests,
        deviceSize,
        priceDetails
    ) => {
        const consolidate =
            deviceSize !== 'sm' &&
            !isMobile &&
            evaluationIsVariant(abacusTests[VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY], 1);

        return {
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            firstPaymentData,
            superlativeBadges,
            consolidate,
            currencyConversionLabel: priceDetails.currencyConversionLabel
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
